import { memo, useState } from 'react'
import { useIntl } from 'react-intl'
import { mdiEye, mdiEyeOff } from '@mdi/js'
import { ErrorMessage, Field, FieldProps } from 'formik'

import { fieldsMessages } from '../messages'
import { passwordFieldMessages } from './messages'
import {
  CommonStyledInput,
  StyledInputError,
  StyledInputLabel,
  StyledInputLabelWrapper,
} from 'components/Input/styles'
import {
  RevealPasswordButton,
  RevealPasswordIcon,
  StyledPasswordWrapper,
} from './styles'
import { CustomFieldProps } from '../types'

interface PasswordFieldProps extends CustomFieldProps {
  wrapperClassName?: string
  inputId?: string
}

function PasswordField({
  label,
  wrapperClassName,
  showLabel,
  inputId,
  ...props
}: PasswordFieldProps) {
  const { formatMessage } = useIntl()

  const { name, placeholder } = props
  const idInput = inputId || name

  const [passwordRevealed, setPasswordRevealed] = useState(false)

  const validatePassword = (value: string) => {
    let error
    if (!value) {
      error = formatMessage(fieldsMessages.requiredField)
    }
    return error
  }

  return (
    <Field name={name}>
      {({ field, form: { errors, touched } }: FieldProps) => (
        <StyledPasswordWrapper className={wrapperClassName}>
          {label && <label htmlFor={idInput}>{label}</label>}
          {showLabel && field?.value && (
            <StyledInputLabelWrapper>
              <StyledInputLabel htmlFor={idInput}>
                {placeholder}
              </StyledInputLabel>
            </StyledInputLabelWrapper>
          )}
          <CommonStyledInput
            as={Field}
            type={passwordRevealed ? 'text' : 'password'}
            id={idInput}
            placeholder={
              placeholder ??
              `${formatMessage(passwordFieldMessages.placeholder)}`
            }
            validate={validatePassword}
            {...props}
          />
          <StyledInputError>
            <ErrorMessage name={props.name} />
          </StyledInputError>
          <RevealPasswordButton
            type="button"
            onClick={() => setPasswordRevealed(!passwordRevealed)}
            title="Reveal"
          >
            <RevealPasswordIcon
              path={passwordRevealed ? mdiEye : mdiEyeOff}
              size={1}
              horizontal
              vertical
            />
          </RevealPasswordButton>
        </StyledPasswordWrapper>
      )}
    </Field>
  )
}

export default memo(PasswordField)
